import { GameTicketProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameTicketProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
/**
 * TicketPortraitProperties.ts
 */
export class TicketPortraitProperties extends GameTicketProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.symbolPanelProperties.position.set(96, 425);
        this.symbolPanelProperties.scale.set(1);
        this.symbolPanelProperties.layout = new GridLayout(5, 5, 165, 166);
        this.reelAreaProperties.position.set(99, 430);
    }
    equals(other) {
        return false;
    }
}
